import React, { Component } from 'react';

import './form-helper.scss';

class FormHelper extends Component {
	componentDidMount() {
		window.addEventListener('click', (event) => this.handleClickOutside(event));
	}

	componentWillUnmount() {
		window.removeEventListener('click', (event) => this.handleClickOutside(event));
	}

	handleClickOutside(event) {
		const target = this.props.options.identifier === 'monthly_budget_amount' ?
			this.props.monthlyInputNode : this.props.dailyInputNode;

		if (
			!this.formHelperDiv
			|| event.target === target
		) {
			return;
		}

		this.props.options.cancel.callback(event);
	}

	render() {
		const options = this.props.options;
		const saveBtn = options.save ? (
			<button
				className="save-btn"
				onClick={options.save.callback}>
				{options.save.txt}
			</button>
		): null;

		const cancelBtn = options.cancel ? (
			<button
				className="cancel-btn"
				onClick={options.cancel.callback}>
				{options.cancel.txt}
			</button>
		) : null;

		return (
			<div className="form-helper-container">
				<div
					ref={(node) => this.formHelperDiv = node}
					className={`form-helper ${options.identifier}`}>
					<div className="buttons">
						{saveBtn}
						{cancelBtn}
					</div>
				</div>
			</div>
		);
	}
}

export default FormHelper;
